import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { projectDetailsInfo } from './api_project';

const initialState = {};

export const fetchProjectDetailsData = createAsyncThunk(
  'ui/fetchProjectDetailsData',
  async (obj, thunkAPI) => {
    const { getState } = thunkAPI;
    const response = await projectDetailsInfo(obj);
    return response.data;
  }
);

const projectDetailsSlice = createSlice({
  name: 'projectDetails',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectDetailsData.pending, (state) => {
        return {
          ...state,
          status: 'loading',
          detailsLoaded: false,
          detailsFetchFailed: false,
          details: initialState,
        };
      })
      .addCase(fetchProjectDetailsData.fulfilled, (state, action) => {
        return {
          ...state,
          status: 'idle',
          details: action.payload,
          detailsFetchFailed: false,
          detailsLoaded: true,
        };
      })
      .addCase(fetchProjectDetailsData.rejected, (state) => {
        return {
          ...state,
          detailsFetchFailed: true,
          status: 'idle',
          detailsLoaded: true,
        };
      });
  },
});

export const getProjectDetails = (state) => state.projectDetails?.details;

export default projectDetailsSlice.reducer;
